import api from './index'
import { axios } from '@/utils/request'

export function createSection(parameter) {
  return axios({
    url: api.BaseURL + api.Section + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListSection(parameter) {
  return axios({
    url: api.BaseURL + api.Section + 'list',
    method: 'GET',
    params: parameter
  })
}

export function getDetailSection(parameter) {
  return axios({
    url: api.BaseURL + api.Section + 'detail',
    method: 'GET',
    params: parameter
  })
}

export function updateSection(parameter) {
  return axios({
    url: api.BaseURL + api.Section + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteSection(parameter) {
  return axios({
    url: api.BaseURL + api.Section + 'delete',
    method: 'POST',
    data: parameter
  })
}